module.exports = __webpack_public_path__ + "img/mainSlide-5.df9a03bd.jpg";